import React, { useState, useEffect } from 'react';
import { User, Link } from 'lucide-react';
import pb from '../pocketbase';

const ProfilePage = () => {
    const user = pb.authStore.model;
    const [discordLink, setDiscordLink] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user?.username) return;
        pb.collection('discord_users').getFullList({
            filter: `username = "${user.username}"`
        })
        .then(records => {
            if (records.length > 0) setDiscordLink(records[0]);
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    }, [user?.username]);

    return (
        <div style={styles.container}>
            <h1 style={styles.title} className="tvs-title-gradient">Mon Profil</h1>

            <div style={styles.card} className="fade-in-up tvs-card-hover">
                <div style={styles.avatarRow}>
                    <div style={styles.avatar}>
                        <User size={36} color="#ff4444" />
                    </div>
                    <div>
                        <h2 style={styles.username}>{user?.username}</h2>
                        {user?.isAdmin && <span style={styles.badge}>Admin</span>}
                    </div>
                </div>
            </div>

            <div style={{...styles.card, animationDelay: '80ms'}} className="fade-in-up tvs-card-hover">
                <div style={styles.cardHeader}>
                    <Link size={18} color="#7289da" />
                    <h3 style={styles.cardTitle}>Compte Discord lié</h3>
                </div>
                {loading ? (
                    <p style={styles.muted}>Chargement...</p>
                ) : discordLink ? (
                    <div>
                        <p style={styles.discordTag}>{discordLink.discord_mention}</p>
                        <p style={styles.discordId}>ID : {discordLink.discord_id}</p>
                    </div>
                ) : (
                    <div>
                        <p style={styles.muted}>Aucun compte Discord lié.</p>
                        <p style={styles.hint}>
                            Utilise la commande suivante sur le serveur Discord pour lier ton compte :
                        </p>
                        <code style={styles.code}>
                            /link-player {user?.username} @TonPseudoDiscord
                        </code>
                    </div>
                )}
            </div>
        </div>
    );
};

const styles = {
    container: {
        padding: '40px 20px',
        maxWidth: '560px',
        margin: '0 auto',
        color: 'white'
    },
    title: {
        color: '#ff4444',
        marginBottom: '30px',
        fontSize: '1.8rem'
    },
    card: {
        backgroundColor: '#161616',
        border: '1px solid #333',
        borderRadius: '12px',
        padding: '24px',
        marginBottom: '20px'
    },
    avatarRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '20px'
    },
    avatar: {
        width: '64px',
        height: '64px',
        backgroundColor: '#2a2a2a',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
    },
    username: {
        margin: '0 0 8px',
        fontSize: '1.4rem'
    },
    badge: {
        background: 'linear-gradient(135deg, #ff6b6b, #ff4444)',
        color: 'white',
        padding: '3px 10px',
        borderRadius: '12px',
        fontSize: '0.75rem',
        fontWeight: 'bold',
        boxShadow: '0 2px 10px rgba(255,68,68,0.35)'
    },
    cardHeader: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        marginBottom: '16px'
    },
    cardTitle: {
        margin: 0,
        color: '#aaa',
        fontSize: '1rem',
        fontWeight: 'normal'
    },
    discordTag: {
        color: '#7289da',
        fontWeight: 'bold',
        fontSize: '1.1rem',
        margin: '0 0 6px'
    },
    discordId: {
        color: '#555',
        fontSize: '0.8rem',
        margin: 0
    },
    muted: {
        color: '#666',
        margin: '0 0 10px'
    },
    hint: {
        color: '#888',
        fontSize: '0.85rem',
        margin: '0 0 10px'
    },
    code: {
        display: 'block',
        backgroundColor: '#0a0a0a',
        border: '1px solid #333',
        borderRadius: '6px',
        padding: '10px 14px',
        color: '#facc15',
        fontSize: '0.85rem',
        fontFamily: 'monospace'
    }
};

export default ProfilePage;
